import { View } from 'foundations-components/components/View';
import { styled } from '../utils/styled';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const COMMENT_BUTTON_WIDTH = 116.7;
const CANCEL_BUTTON_WIDTH = 96.63;
const ButtonSkeleton = styled.div.withConfig({
  displayName: "MiniCommenterSkeleton__ButtonSkeleton",
  componentId: "sc-1j07ero-0"
})(["background-color:", ";height:40px;width:", "px;margin-right:12px;"], ({
  theme
}) => theme.color['fill-field-default'], ({
  width
}) => width);
const ButtonsSkeleton = styled.div.withConfig({
  displayName: "MiniCommenterSkeleton__ButtonsSkeleton",
  componentId: "sc-1j07ero-1"
})(["margin-top:12px;display:flex;"]);
export default function MiniCommenterSkeleton({
  hasModuleParentComment
}) {
  const editorAndButtons = /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(View, {
      blockSize: "137px",
      borderRadius: "200",
      backgroundColor: "fill-field-default"
    }), /*#__PURE__*/_jsxs(ButtonsSkeleton, {
      children: [/*#__PURE__*/_jsx(ButtonSkeleton, {
        width: COMMENT_BUTTON_WIDTH
      }), /*#__PURE__*/_jsx(ButtonSkeleton, {
        width: CANCEL_BUTTON_WIDTH
      })]
    })]
  });
  return /*#__PURE__*/_jsx(View, {
    padding: "400",
    children: hasModuleParentComment ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(View, {
        blockSize: "100px",
        borderRadius: "200",
        backgroundColor: "fill-field-default",
        marginBlockEnd: "400"
      }), /*#__PURE__*/_jsx(View, {
        marginInlineStart: "400",
        children: editorAndButtons
      })]
    }) : editorAndButtons
  });
}